import React from 'react';
import { Badge } from 'react-bootstrap';

const NotificationItem = ({ notification, onClick }) => {
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getIconPath = (icon) => {
    const iconMap = {
      'bell': '/images/bell.svg',
      'approved': '/images/approved.svg',
      'agreement': '/images/agreement.svg',
      'rfq': '/images/buy.svg',
      'feedback': '/images/shown.svg',
      'interested': '/images/hand.svg',
      'shortlisted': '/images/approved.svg',
      'rejected': '/images/delete.svg',
      'expired': '/images/calendar.svg',
      'nda': '/images/nda.svg',
      'won': '/images/trophy.svg',
      'lost': '/images/sad.svg',
      'proposal': '/images/proposal.svg',
      'documents': '/images/documents.svg',
      'completed': '/images/completed.svg',
      'assignment': '/images/total.svg',
      'milestone': '/images/milestone.svg',
      'warning': '/images/warning.svg',
      'payment': '/images/payment.svg',
    };
    return iconMap[icon] || '/images/bell.svg';
  };

  return (
    <div 
      className={`notification-item p-3 border-bottom ${!notification.read ? 'bg-light' : ''}`}
      onClick={onClick}
      style={{ 
        cursor: notification.entityId ? 'pointer' : 'default',
        transition: 'background-color 0.2s',
      }}
      onMouseEnter={(e) => {
        if (notification.entityId) {
          e.currentTarget.style.backgroundColor = '#f8f9fa';
        }
      }}
      onMouseLeave={(e) => {
        if (!notification.read) {
          e.currentTarget.style.backgroundColor = '#f8f9fa';
        } else {
          e.currentTarget.style.backgroundColor = 'transparent';
        }
      }}
    >
      <div className="d-flex align-items-start">
        <div className="notification-icon me-3" style={{ minWidth: '32px' }}>
          <img 
            src={getIconPath(notification.icon)} 
            alt="" 
            width={32} 
            height={32}
            style={{ filter: notification.read ? 'grayscale(50%)' : 'none' }}
          />
        </div>
        <div className="flex-grow-1">
          <div className="d-flex justify-content-between align-items-start mb-1">
            <strong 
              className={`${!notification.read ? 'text-dark' : 'text-muted'}`}
              style={{ fontSize: '0.95rem' }}
            >
              {notification.title}
            </strong>
            {!notification.read && (
              <span className="badge bg-primary rounded-pill ms-2">New</span>
            )}
          </div>
          <p 
            className="mb-2 text-muted" 
            style={{ fontSize: '0.875rem', lineHeight: '1.4' }}
          >
            {notification.message}
          </p>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            {notification.displayId && (
              <Badge 
                bg="primary" 
                className="px-2 py-1"
                style={{ fontSize: '0.75rem' }}
              >
                {notification.displayId}
              </Badge>
            )}
            <small className="text-muted" style={{ fontSize: '0.75rem' }}>
              {formatTimestamp(notification.createdAt)}
            </small>
            {notification.actionBy && (
              <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                • by {notification.actionBy}
              </small>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;